import { render, staticRenderFns } from "./ListCollaborators.vue?vue&type=template&id=7af59b0b&scoped=true&"
import script from "./ListCollaborators.vue?vue&type=script&lang=js&"
export * from "./ListCollaborators.vue?vue&type=script&lang=js&"
import style0 from "./ListCollaborators.vue?vue&type=style&index=0&id=7af59b0b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af59b0b",
  null
  
)

export default component.exports